import React from 'react'
import './Button.css'

export interface ButtonProps {
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'ghost' | 'success'
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  loading?: boolean
  fullWidth?: boolean
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  className?: string
  href?: string
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  href,
  ...props
}) => {
  const baseClass = 'btn'
  const variantClass = `btn-${variant}`
  const sizeClass = `btn-${size}`
  const widthClass = fullWidth ? 'btn-full-width' : ''
  const stateClass = disabled ? 'btn-disabled' : loading ? 'btn-loading' : ''
  
  const buttonClasses = [
    baseClass,
    variantClass,
    sizeClass,
    widthClass,
    stateClass,
    className
  ].filter(Boolean).join(' ')

  if (href) {
    return (
      <a 
        href={href}
        className={buttonClasses}
        {...props}
      >
        {loading && <span className="btn-spinner" />}
        {children}
      </a>
    )
  }

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && <span className="btn-spinner" />}
      {children}
    </button>
  )
}

export default Button 